import typeHelper from './typeHelper'
import { IS_DESKTOP } from './constants'

const IsDesktop = typeHelper(IS_DESKTOP)

export default IsDesktop
